import React from "react";

const Wifi = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.2857 13.7574C15.1889 12.6716 13.6737 12 12 12C10.3263 12 8.8111 12.6716 7.71429 13.7574M19.1429 10.9289C17.3148 9.11929 14.7895 8 12 8C9.21054 8 6.68516 9.11929 4.85714 10.9289M22 8.10051C19.4408 5.567 15.9052 4 12 4C8.09476 4 4.55922 5.567 2 8.1005M14.0203 18C14.0203 19.1046 13.1158 20 12 20C10.8842 20 9.97969 19.1046 9.97969 18C9.97969 17.4477 10.2058 16.9477 10.5714 16.5858C10.937 16.2239 11.4421 16 12 16C12.5579 16 13.063 16.2239 13.4286 16.5858C13.7942 16.9477 14.0203 17.4477 14.0203 18Z"
        stroke="#00A3BC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Wifi;
